import classNames from "classnames";
import React from "react";
import { Profile } from "../../util/profile.util";
import { AvatarCluster } from "./AvatarCluster";
import { Item } from "./Item";

export const Event: React.FC<{ profiles: Profile[]; variant?: string }> = ({
  children,
  profiles,
  variant = "AI_CHAT",
}) => {
  return (
    <Item
      right={<div className="cw-body-sm">{children}</div>}
      left={
        <div
          className={classNames("cw-w-8 cw-h-8 cw-flex cw-items-center cw-justify-center", {
            "cw-bg-neutral": variant === "AI_CHAT",
            "cw-bg-default": variant !== "AI_CHAT",
          })}
        >
          <AvatarCluster profiles={profiles} />
        </div>
      }
    />
  );
};
